import { useCallback } from "react";
import { trackDashboardCtaClicked } from "analytics";
import NextMoveCard from ".";
import Translate from "translate/Translate";
import { useNextMoveMemberContext } from "./useNextMoveMemberContext";

const NavigationTeamNextMoveCard = () => {
  const { memberNeedsToTalkToNav } = useNextMoveMemberContext();

  const onActionClick = useCallback(() => {
    trackDashboardCtaClicked({
      workflow: "dashboard",
      ctaLocation: "next_move_card",
      ctaId: "navigation_team"
    });
  }, []);

  if (!memberNeedsToTalkToNav) {
    return null;
  }

  return (
    <NextMoveCard
      id="contact-navigation-team-next-move"
      tag="inProgress"
      title={<Translate text="Connect with the navigation team" />}
      body={
        <Translate text="Based on what you've shared, we recommend you talk with a member of our navigation team. They can help you understand the services and tests for your health and goals. A member of our navigation team will get in contact with you." />
      }
      link={{
        onClick: onActionClick,
        overrideClick: true,
        text: "Learn more",
        url: "#"
      }}
    />
  );
};

export default NavigationTeamNextMoveCard;
